import { SMSorEmailCommunicationType } from '../../Enums/FormEnums';
import {getJson, postObjectWithApiError, IResultAndError} from '../../lib/ChoiceApi';
import {NoTzDate} from "../../lib/DateUtils";
 
export interface IPaymentBatchUpdateInputs
{
    update_command: PaymentBatchUpdateType,
    payment_batch_id ?: number,
    image_id ?: number,
    payment_batch_date ?: NoTzDate,
    description ?: string,
    total_amount ?: number,
    item_count ?: number
}
export interface IPaymentBatchUpdateResult {
    errorCode: number,
    errorMessage?: string,
    paymentBatchId?: number
} 
export interface IPaymentBatchUpdateIDInputs {
    update_command: PaymentBatchUpdateIdType, 
    payment_batch_id: number,
    table_ids: string,
    table_type_id: PaymentBatchIdType
}
export interface IPaymentBatchUpdateIDs {    
    tableID: number,
    recordMessage: string,
    recordStatus: number
}
export interface PaymentBatchIDsResponse {
    paymentBatchIDList?: IPaymentBatchUpdateIDs[],
    isSuccess: boolean,
    message?: string
}
export interface IPaymentBatchValues {
    paymentBatchId: number,
    status?: number,
    statusDescription?: string,
    paymentBatchDate?: NoTzDate, 
    paymentBatchImageId?: number,
    paymentBatchFileName?: string,
    description?: string,
    totalAmount: number,
    totalPosted: number,
    totalApplied: number,
    totalUnapplied: number,
    itemCount: number,
    itemsPosted: number,
    itemsApplied: number,
    assignedUserId?: string,
    createdBy?: string,  
    completedBy?: string
}
export interface IPaymentBatchDeposits {
    paymentBatchId: number,
    depositID: number,
    depositDate?: NoTzDate,
    payerEid?: number,
    payerName?: string,
    paymentMethod?: number,
    paymentMethodDescription?: string,
    paymentType?: number,
    paymentTypeDescription?: string,
    checkNumber?: string,
    depositAmount: number,
    depositApplied: number,
    depositUnapplied: number
} 
export interface IPaymentBatchReceipts {
    paymentBatchId: number,
    receiptID: number,
    receiptDate?: NoTzDate,
    patientId?: number,
    patientName?: string,
    paymentMethod?: number,
    paymentMethodDescription?: string,
    paymentType?: number,
    paymentTypeDescription?: string,
    checkNumber?: string,
    paidAmount: number,
    appliedAmount: number,
    unappliedAmount: number
}
export interface IPaymentBatchReport {
    ID: string,
    Date?: NoTzDate,
    payerName?: string,
    paymentMethod?: string,
    paymentType?: string,
    checkNumber?: string,
    postAmount: number,
    appliedAmount: number,
    unappliedAmount: number, 
}
export interface IPaymentBatchDetailsResponse {
    paymentBatchValueList?: IPaymentBatchValues[],
    paymentBatchDepositList?: IPaymentBatchDeposits[],
    paymentBatchReceiptList?: IPaymentBatchReceipts[], 
    isSuccess: boolean,
    message?: string
}
export interface IDepositReceiptsSearch { 
    depositsList?: IDepositsSearch[],
    receiptsList?: IReceiptsSearch[], 
    isSuccess: boolean,
    message?: string
}
export interface IDepositsSearch { 
    depositID?: number,
    depositDate?: NoTzDate,
    payerEid?: number,
    payerName?: string, 
    depositAmount?: number
}
export interface IReceiptsSearch { 
    receiptID?: number,
    receiptDate?: NoTzDate,
    patientId?: number,
    patientName?: string, 
    paidAmount?: number
}

export interface IEReceiptPayload { 
    entityId?: number,
    communicationType?: SMSorEmailCommunicationType,
    overrideValue?: string,
    receiptAmount?: string
}

export enum PaymentBatchStatus {
    New = 0,
    Completed = 1,
    Removed = -1
}
export enum PaymentBatchIdType {
    Deposit = 1,
    Receipt = 2
}
export enum PaymentBatchUpdateType {
    Reopen = 1,
    Reassign = 2,
    Complete = 3,
    Attachment = 4,
    Update = 5,
    Insert = 6,
    Remove = 7
}
export enum PaymentBatchUpdateIdType {
    Connect = 1,
    Remove = 2
}
export const paymentbatch = {
    async UpdatePaymentBatch(payload: IPaymentBatchUpdateInputs): Promise<IResultAndError<IPaymentBatchUpdateResult>> {
        return postObjectWithApiError("api/Billing/PaymentBatch/UpdatePaymentBatch", payload);
    }
}
export const paymentbatchid = {
    async UpdatePaymentBatchId(payload: IPaymentBatchUpdateIDInputs): Promise<IResultAndError<PaymentBatchIDsResponse>> {
        return postObjectWithApiError("api/Billing/PaymentBatch/UpdatePaymentBatchId", payload);
    }
}
export const paymentbatchdetails = {
    async PaymentBatchDetails(paymentBatchId: number) {
        return getJson(`api/Billing/PaymentBatch/PaymentBatchDetails/${paymentBatchId}`);
    }
}
export const paymentbatchidsearch = {
    async PaymentBatchIDSearch(paymentBatchTypeID: PaymentBatchIdType, startDate: NoTzDate, endDate : NoTzDate) {
        return getJson(`api/Billing/PaymentBatch/PaymentBatchIDSearch/${paymentBatchTypeID}/${startDate}/${endDate}`);
    }
}
